
import React from 'react';
import { Recommendation } from '@/types/assessment';
import GroupedRecommendationsSection from './recommendations/GroupedRecommendationsSection';

interface RecommendationsSectionProps {
  recommendations: Recommendation[];
  maxInitialDisplay?: number;
  onExport?: () => void;
  forceExpanded?: boolean;
}

const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({ 
  recommendations,
  onExport,
  forceExpanded = false
}) => {
  return <GroupedRecommendationsSection recommendations={recommendations} onExport={onExport} forceExpanded={forceExpanded} />;
};

export default RecommendationsSection;
